import { GoJsModelProperties } from '@y42/gojs';
import { Binding, GraphObject, Part } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageNodeBinding,
  DataLineageUINode,
} from '../../../../../../state/data-lineage-diagram';
import { DataLineageThemeColors } from './../../../../../../state/data-lineage-diagram/config/data-lineage.config';

export const linkStrokeBinding = () =>
  new Binding('stroke', '', (object: GraphObject, diagramPart: Part) => {
    const hasDarkMode = diagramPart.diagram?.model.modelData[GoJsModelProperties.HasDarkMode];

    if (object.part?.isHighlighted) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Arrow.Highlighted
        : DataLineageThemeColors.Light.Arrow.Highlighted;
    }
    if ((object.part?.data as DataLineageUINode)?.[DataLineageNodeBinding.PathSelection]) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Arrow.Highlighted
        : DataLineageThemeColors.Light.Arrow.Highlighted;
    }
    return hasDarkMode ? DataLineageThemeColors.Dark.Arrow.Default : DataLineageThemeColors.Light.Arrow.Default;
  }).ofObject();

export const linkZOrderBinding = () =>
  new Binding('zOrder', '', (object: GraphObject) => {
    if (object.part?.isHighlighted) {
      return dataLineageDiagramConfig.zOrder.highlighted;
    }
    if ((object.part?.data as DataLineageUINode)?.[DataLineageNodeBinding.PathSelection]) {
      return dataLineageDiagramConfig.zOrder.selected;
    }
    return dataLineageDiagramConfig.zOrder.default;
  }).ofObject();
